module.exports = __webpack_public_path__ + "static/media/photobook-asanov-footer.1ad2e272.jpg";